import { makeStyles } from "@material-ui/styles"

const useStyle = makeStyles((theme) => ({
  dropzone: {
    padding: 48,
    minHeight: 56,
    borderRadius: 5,
    border: `2px dashed ${theme.palette.primary.main}4d`,
    cursor: "pointer",
  },
  iconBackground: {
    backgroundColor: "rgba(38, 218, 164, 0.1)",
    width: 64,
    height: 64,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 12,
    marginBottom: 24,
  },
  textField: {
    height: 32,
    maxWidth: 128,
    marginBottom: "0 !important",
    borderRadius: 5,
    "& input": {
      height: 32,
      padding: "0 4px",
      textAlign: "center",
    },
  },
  bordered: {
    border: `1px solid ${theme.palette.text.primary}`,
  },
  borderedTransparent: {
    border: `1px solid transparent`,
  },
  workTypeBlockActive: {
    border: "1px solid " + theme.palette.primary.main,
    color: theme.palette.primary.main,
    "&.level0": {
      backgroundColor: theme.props.selections.level0,
    },
    "&.level1": {
      backgroundColor: theme.props.selections.level1,
    },
    "&.level2": {
      backgroundColor: theme.props.selections.level2,
    },
    "&.level3": {
      backgroundColor: theme.props.selections.level3,
    },
    
  },
  columnSelect: {
    width: 56,
    minWidth: 56,
    "& > div": {
      height: 32,
    },
    "& input, & .MuiSelect-root": {
      padding: "4px 12px 4px 8px",
    },
    "& svg": {
      right: 3,
    }
  },
  fastModeTextColumnName: {
    width: 124,
    marginRight: 4,
    marginBottom: "0 !important",
    "& > div": {
      height: 32,
    },
    "& input": {
      height: 32,
      padding: 4,
    },
  },
  workTypeAutocompleteTextField: {
    height: 32,
    "& > div": {
      padding: "0 !important",
    },
    "& input": {
      height: 32,
    },
  },
  endAdornment: {
    right: "3px !important"
  },
  previewRoot: {
    minHeight: 320
  },
  previewSpinner: {
    margin: "160px auto",
  },
  scrollableContainer: {
    width: "calc(100% + 48px)",
    margin: "0 -24px",
    padding: "0 24px 12px",
  },
  sticky: {
    position:"sticky",
    left: 0,
  }
}));

export default useStyle;
